module.exports = __webpack_public_path__ + "img/info-school.d9d8f157.svg";